import React, { createRef } from "react";

import {
  StyledCitationTitleType,
  StyledCitationTextType,
  StyledCitationButtonContainer,
} from "./_.styled";

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogTitleActions,
  Button,
} from "@ebscois/react-component-library";

import { logTopicCiteCopyClicked } from "../../util/analytics";

const getCurrentDate = () => {
  return new Date().toLocaleDateString(undefined, { dateStyle: "long" });
};

const CitationDialog = ({
  isCitationDialogOpen,
  setIsCitationDialogOpen,
  info,
  handleCopyToClipboard,
  telemetryData,
}) => {
  const title = "Citation";
  const infoText =
    info?.replace("{{DATE}}", getCurrentDate()) || "Citation was not found.";
  const selectionRef = createRef();
  const handleCitationDialogCancel = () => {
    setIsCitationDialogOpen(false);
  };
  return (
    <Dialog
      isOpen={isCitationDialogOpen}
      data-testid="citation-dialog"
      maxWidth="lg"
      aria-labelledby="citation-dialog-title"
      onRequestClose={handleCitationDialogCancel}
    >
      <DialogTitle>
        <StyledCitationTitleType
          id="citation-dialog-title"
          element="h2"
          fontFamily="secondary"
        >
          {title}
        </StyledCitationTitleType>
        <DialogTitleActions
          data-testid="title-actions"
          onRequestClose={handleCitationDialogCancel}
        />
      </DialogTitle>
      <StyledCitationTextType ref={selectionRef}>
        {infoText}
      </StyledCitationTextType>
      <DialogActions justify="center">
        <StyledCitationButtonContainer>
          <Button
            onClick={(event) => {
              event.preventDefault();
              handleCopyToClipboard(
                selectionRef,
                "Citation has been copied to clipboard",
                "Error"
              );
              logTopicCiteCopyClicked(telemetryData);
              setIsCitationDialogOpen(false);
            }}
            data-testid="copy-citation-button"
          >
            Copy Citation
          </Button>
        </StyledCitationButtonContainer>
      </DialogActions>
    </Dialog>
  );
};

CitationDialog.displayName = "CitationDialog";
export default CitationDialog;
